<template>
  <div>
    <b-row>
      <b-col cols="12" xl="12">
        <app-filtro
          :fechaDesde="fechaDesdeParam"
          :fechaHasta="fechaHastaParam"
          :sortByDescending="sortByDescending"
          @filtrar="filtrar">
        </app-filtro>  
      </b-col>      
    </b-row>

    <b-row>
      <b-col cols="12" xl="12">  
        <transition name="slide">
        <b-card header="Registro de Encuestas">
          <b-table hover
              responsive="sm" 
              class="registro"
              :busy="tableBusy"
              :items="encuestasUsuarios"
              :fields="fields" 
              @row-clicked="consultar">
            <div slot="table-busy" class="text-center">
              <b-spinner class="table-spinner" label="Spinning" />
            </div>              
            <template v-slot:cell(fechaRegistro)="data">
              {{ data.item.fechaRegistro | fecha }}
            </template>
            <template v-slot:cell(fechaEncuesta)="data">
              {{ data.item.fechaEncuesta | fecha }}
            </template>
            <template v-slot:cell(calificacion)="data">
              {{ data.item.calificacion | numero(2, true) }}
            </template>
            
            <template v-slot:cell(opciones)="data">
              <b-dropdown variant="link" toggle-class="text-decoration-none" no-caret>
                <template slot="button-content">
                  <i class="fa fa-ellipsis-v"></i>
                </template>
                
                <b-dropdown-item
                    :disabled="!completarHabilitado(data.item)"
                    @click.stop="completarEncuesta(data.item)">
                  <i class="fa fa-edit"></i>Completar Encuesta</b-dropdown-item>

                <!-- :disabled="!borradoHabilitado(data.item)" -->
                <b-dropdown-item 
                    disabled
                    @click.stop="borrarItem(data.item)">
                  <i class="fa fa-remove"></i>Borrar Encuesta</b-dropdown-item>
              </b-dropdown>
            </template>
          </b-table>
          <nav>
            <b-pagination size="sm" 
              :total-rows="totalRegistros" 
              :per-page="registrosPorPagina" 
              v-model="paginaActual" prev-text="Prev." next-text="Prox."/>
            <label class="pagination-description">{{ paginacion }}</label>
          </nav>
        </b-card>
        </transition>
      </b-col>
    </b-row>

    <!-- <div class="fixed-btn">
      <div class="list-dropdown-btn">
        <b-dropdown variant="link" toggle-class="text-decoration-none" no-caret>
          <template slot="button-content">
            <i class="fa fa-ellipsis-v fa-2x" aria-hidden="true"></i>
          </template>
          <b-dropdown-item
              @click.stop="exportXls">
            <i class="fa fa-file-excel-o"></i>Exportar Listado de Evaluaciones</b-dropdown-item>
        </b-dropdown>
      </div>
    </div> -->

    <app-mensaje
      :modalMsj="modalMsj"
      :modalMensaje="modalMensaje"
      @okAction="okAction"
      @hiddenAction="hiddenAction">
    </app-mensaje>

    <app-confirm
      :confirmModalVisible="confirmModalVisible"
      :confirmMsj="confirmMsj"
      :confirmOkTitle="confirmOkTitle"
      :confirmCancelTitle="confirmCancelTitle"
      @confirmOk="confirmOk"
      @confirmCancel="confirmCancel">
    </app-confirm>
  </div>
</template>

<script>
import Filtro from './listFiltro.vue';
import Mensaje from  '../shared/msjModal.vue';
import Confirm from  '../shared/confirmModal.vue';
import { msjModal, confirmModal } from '../../mixins/modalDialogs'
import { createHelpers } from 'vuex-map-fields';
import moment from 'moment';

const { mapFields } = createHelpers({
  getterType: 'encuestasUsuarios/getField',
  mutationType: 'encuestasUsuarios/updateField',
});

export default {
  name: 'EncuestasUsuariosList',
  components: {
    appFiltro: Filtro,
    appMensaje: Mensaje,
    appConfirm: Confirm,
  },
  mixins: [
    msjModal, 
    confirmModal, 
  ],
  data: () => {
    return {
      fields: [
        {
          key: 'fechaRegistro',
        },
        {
          key: 'fechaEncuesta',
        },
        { 
          key: 'usuarioReferido',
          label: 'Referido'
        },
        { 
          key: 'usuario',
          label: 'Encuestado'
        },
        { 
          key: 'encuestaUsuarioTipo',
          label: 'Tipo Encuesta'
        },
        { 
          key: 'referencia',
        },
        { 
          key: 'calificacion',
          class: 'text-right' 
        },
        {
          key: 'opciones',
          label: '',
          class: 'text-center'
        },
      ],

      tableBusy: false,

      opcionBorrarEncuesta: false,
      opcionCompletarEncuesta: false
    }
  },
  computed: {
    ...mapFields([
      'encuestasUsuarios',
      'paginaActual',
      'registrosPorPagina',
      'totalRegistros',
      'totalPaginas',
      'fechaDesde',
      'fechaHasta',
      'usuario',
      'sortByDescending'
    ]),
    usuarioId() {
      return parseInt(this.$store.getters['user/userId']);
    },
    fechaDesdeParam() {
      return moment(this.fechaDesde).format('YYYY-MM-DD');
    },
    fechaHastaParam() {
      return moment(this.fechaHasta).format('YYYY-MM-DD');
    },
    paginacion() {
      let paginaActual = 0;
      let registrosPorPagina = 0;
      let totalPaginas = 0;
      let totalRegistros = 0;
      let registroDesde = 0;
      let registroHasta = 0;

      if (this.paginaActual) {
        if (!isNaN(this.paginaActual)) {
          paginaActual = parseInt(this.paginaActual);
        }
      }
      if (this.registrosPorPagina) {
        if (!isNaN(this.registrosPorPagina)) {
          registrosPorPagina = parseInt(this.registrosPorPagina);
        }
      }
      if (this.totalPaginas) {
        if (!isNaN(this.totalPaginas)) {
          totalPaginas = parseInt(this.totalPaginas);
        }
      }
      if (this.totalRegistros) {
        if (!isNaN(this.totalRegistros)) {
          totalRegistros = parseInt(this.totalRegistros);
        }
      }
      if (totalPaginas == 0) {
        totalPaginas = 1;
      }
      registroDesde = ((paginaActual - 1) * registrosPorPagina) + 1;
      if (registroDesde > totalRegistros) {
        registroDesde = totalRegistros;
      }
      registroHasta = registroDesde + registrosPorPagina - 1;
      if (registroHasta > totalRegistros) {
        registroHasta = totalRegistros;
      }

      return `Pág. ${paginaActual} de ${totalPaginas} - Registros ${registroDesde} a ${registroHasta} de ${totalRegistros} registros`;
    }
  },
  created() {
    let userRolId = parseInt(this.$store.getters['user/rolId']);

    switch (userRolId) {
      case 1:
      case 2: /* Direccion */
      case 4: /* Produccion */
      case 8: /* Calidad */
      case 9: /* Director Ejecutivo */
        this.opcionBorrarEncuesta = true;
        this.opcionCompletarEncuesta = true;
        break;
    }

    this.getItems();
  },  
  methods: {
    filtrar(filtro) {
      this.fechaDesde = filtro.fechaDesde;
      this.fechaHasta = filtro.fechaHasta;
      // this.usuario = filtro.usuario;
      this.sortByDescending = filtro.sortByDescending;
      this.paginaActual = 1;
      
      this.getItems();
    },
    completarHabilitado(item) {
      if (this.opcionCompletarEncuesta) {
        return true;
      }

      if (item.usuarioId == this.usuarioId) {
        return true;
      }

      return false;
    },
    borradoHabilitado(item) {
      if (this.opcionBorrarEncuesta) {
        return true;
      }

      if (item.usuarioId == this.usuarioId) {
        return true;
      }

      return false;
    },
    getItems() {
      this.tableBusy = true;
      this.$store.dispatch('encuestasUsuarios/getEncuestas')
        .then(() => this.tableBusy = false)
        .catch(error => this.showErrorMsj(error));
    },
    consultar (item) {
      this.$router.push({ name: 'EncuestaUsuarioData', 
                          params: { id: item.id }});
    },
    borrarItem (item) {
      this.showModalConfirm('¿Desea borrar la encuesta seleccionada?', 
            this.borrar.bind(this, item.id), 'Si', null, 'No')
    },
    borrar (encuestaUsuarioId) {
      // this.showSpinner();
      // this.$store.dispatch('evaluacionesProveedores/delete', evaluacionProveedorId)
      //   .then(() => this.showModalMsj('La evaluación se borró con éxito', this.getItems, this.getItems, 'light'))
      //   .catch(error => this.showErrorMsj(error))
      //   .finally(() => this.hideSpinner());
    },
    completarEncuesta(item) {
      this.$router.push({ name: 'EncuestaUsuarioCompletar', 
                          params: { id: item.id }});
    },
    // exportXls () {
    //   this.showSpinner();
    //   this.$store.dispatch('evaluacionesProveedores/getList')
    //     .then(() => {
    //       let exportList = Boolean(false); 
    //       let list = this.$store.getters['evaluacionesProveedores/list'];

    //       if (list) {
    //         if (list.length != 0) {
    //           exportList = Boolean(true);
    //         }
    //       }
    //       if (exportList) {
    //         let title= 'Listado de Evaluaciones';
    //         let fileName = 'evaluaciones-proveedores';
    //         let format = [
    //           { titulo: 'Fecha Evaluación', nombre: 'fechaEvaluacion', formato: 'fecha' },
    //           { titulo: 'Proveedor', nombre: 'proveedor', formato: '' },
    //           { titulo: 'Nro.Orden/Nro.Remito', nombre: 'referenciaNumero', formato: '' },
    //           { titulo: 'Referencia', nombre: 'referencia', formato: '' },
    //           { titulo: 'Calificación', nombre: 'calificacion', formato: '' },
    //           { titulo: 'Atención al Cliente', nombre: 'calificacionAtencionCliente', formato: '' },
    //           { titulo: 'Tiempo de Entrega', nombre: 'calificacionTiempoEntrega', formato: '' },
    //           { titulo: 'Costos', nombre: 'calificacionCostos', formato: '' },
    //           { titulo: 'Calidad', nombre: 'calificacionCalidad', formato: '' },
    //           { titulo: 'Usuario', nombre: 'usuario', formato: '' },
    //           { titulo: 'Observaciones', nombre: 'observaciones', formato: '' },
    //         ];

    //         this.exportXLS(title, fileName, list, format);            
    //       } else {
    //         this.showModalMsj('No hay datos para exportar', null, null, 'light')
    //       }
    //     })
    //     .catch(error => this.showErrorMsj(error))
    //     .finally(() => this.hideSpinner());
    // },
  },
  watch: {
    'paginaActual' : function(newVal, oldVal) {
      if ( newVal != 0 && oldVal != 0) {
        this.getItems();
      }
    },    
  }    
}
</script>

<style>
</style>
